module.exports = __webpack_public_path__ + "dd7e28c11c039e3ea1bae4d489a2bafb.svg";